import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import AuthGuard from '../components/AuthGuard';
import { api } from '../lib/api';

function formatTime(dateStr: string) {
  const d = new Date(dateStr);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const h = String(d.getHours()).padStart(2, '0');
  const min = String(d.getMinutes()).padStart(2, '0');
  const s = String(d.getSeconds()).padStart(2, '0');
  return `${y}年${m}月${day}日 ${h}:${min}:${s}`;
}

export default function Cards() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', phone: '', address: '' });
  const [hasApplied, setHasApplied] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [application, setApplication] = useState<any>(null);

  useEffect(() => {
    api.get('/cards/status').then(({ data }) => {
      if (data.has_applied) {
        setHasApplied(true);
        const app = data.application || data.data || {};
        setApplication(app);
        setForm({ name: app.name || '', phone: app.phone || '', address: app.address || '' });
      }
    }).catch(() => {});
  }, []);

  async function handleSubmit() {
    if (hasApplied || submitting) return;
    if (!form.name.trim()) { toast.error('请输入收件人姓名'); return; }
    if (!form.phone.trim()) { toast.error('请输入联系电话'); return; }
    if (!form.address.trim()) { toast.error('请输入邮寄地址'); return; }
    setSubmitting(true);
    try {
      const { data } = await api.post('/cards', { name: form.name.trim(), phone: form.phone.trim(), address: form.address.trim() });
      toast.success('提交成功');
      setHasApplied(true);
      setApplication(data.application || data.data || { created_at: new Date().toISOString() });
    } catch (e: any) {
      toast.error(e?.response?.data?.message || '提交失败');
    } finally {
      setSubmitting(false);
    }
  }

  const statusText = application?.status === 'approved' ? '已通过'
    : application?.status === 'rejected' ? '已拒绝'
    : '系统审核中';

  const submitTime = application?.created_at ? formatTime(application.created_at) : '';

  if (hasApplied) {
    return (
      <div className="max-w-md mx-auto min-h-screen pb-6" style={{ backgroundColor: '#f0e8da' }}>
        <AuthGuard />

        <img src="/images/cardreg_beijing.png" alt="" className="w-full" />

        <div className="px-4 -mt-[450px] relative z-10">
          <div className="bg-[url(/images/cardreg_xixni.png)] bg-[length:100%_100%] bg-no-repeat pt-[48px] px-5 pb-5">
            <div className="space-y-4">
              <div className="flex items-start gap-2.5">
                <img src="/images/cardreg_zhuan.png" alt="" className="w-6 h-6 flex-shrink-0" />
                <span className="text-[#333] text-sm font-bold whitespace-nowrap">登记状态：</span>
                <span className="text-[#2da44e] text-sm font-bold">已完成</span>
              </div>

              <div className="flex items-start gap-2.5">
                <img src="/images/cardreg_shijian.png" alt="" className="w-6 h-6 flex-shrink-0" />
                <span className="text-[#333] text-sm font-bold whitespace-nowrap">提交时间：</span>
                <span className="text-[#666] text-sm">{submitTime}</span>
              </div>

              <div className="flex items-start gap-2.5">
                <img src="/images/cardreg_shenhe.png" alt="" className="w-6 h-6 flex-shrink-0" />
                <span className="text-[#333] text-sm font-bold whitespace-nowrap">审核状态：</span>
                <span className="text-[#666] text-sm">{statusText}</span>
              </div>

              <div className="flex items-start gap-2.5">
                <img src="/images/cardreg_wenxin.png" alt="" className="w-6 h-6 flex-shrink-0" />
                <span className="text-[#333] text-sm font-bold whitespace-nowrap">温馨提示：</span>
                <span className="text-[#666] text-sm leading-relaxed">我们将尽快完成审核，审核结果会通过站内消息通知您，请耐心等待。</span>
              </div>
            </div>
          </div>
        </div>

        <div className="px-4 mt-4 flex gap-3">
          <button onClick={() => navigate('/card-progress')} className="flex-1">
            <img src="/images/cardreg_jindu.png" alt="查看进度" className="w-full" />
          </button>
          <button onClick={() => navigate('/')} className="flex-1">
            <img src="/images/cardreg_fanhui.png" alt="返回首页" className="w-full" />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto min-h-screen bg-[url(/images/tuipeika_beijing.png)] bg-[length:100%_100%] bg-no-repeat bg-top pb-[60px] pt-[175px]" style={{ backgroundColor: '#8b0000' }}>
      <AuthGuard />

      <div className="pt-4 px-4">
        <button onClick={() => navigate(-1)} className="w-8 h-8 flex items-center justify-center rounded-full bg-black/20 text-white">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
        </button>
      </div>

      <div className="px-4">
        <img src="/images/tuipeika_ka.png" alt="退赔卡" className="w-full" />
      </div>

      <div className="px-4 mt-2">
        <div className="bg-[url(/images/tuipeika_tianxie.png)] bg-[length:100%_100%] bg-no-repeat rounded-xl px-4 shadow pt-[40px] pb-[5px]">
          <div className="space-y-2">
            <div className="flex items-center gap-3">
              <img src="/images/tuipeika_shoujian.png" alt="" className="w-6 h-6 flex-shrink-0" />
              <span className="text-[#333] text-xs font-bold w-[70px] flex-shrink-0">收件姓名：</span>
              <input
                type="text"
                placeholder="请输入收件姓名"
                value={form.name}
                onChange={e => setForm({ ...form, name: e.target.value })}
                className="flex-1 bg-[url(/images/tuipeika_shuru.png)] bg-cover bg-no-repeat rounded-lg px-3 py-1.5 text-xs text-[#333] placeholder-gray-400 outline-none focus:ring-2 focus:ring-[#c4161c]/20"
              />
            </div>

            <div className="flex items-center gap-3">
              <img src="/images/tuipeika_dinahu.png" alt="" className="w-6 h-6 flex-shrink-0" />
              <span className="text-[#333] text-xs font-bold w-[70px] flex-shrink-0">联系电话：</span>
              <input
                type="tel"
                placeholder="请输入联系电话"
                value={form.phone}
                onChange={e => setForm({ ...form, phone: e.target.value.replace(/\D/g, '').slice(0, 11) })}
                maxLength={11}
                className="flex-1 bg-[url(/images/tuipeika_shuru.png)] bg-cover bg-no-repeat rounded-lg px-3 py-1.5 text-xs text-[#333] placeholder-gray-400 outline-none focus:ring-2 focus:ring-[#c4161c]/20"
              />
            </div>

            <div className="flex items-center gap-3">
              <img src="/images/tuipeika_dizhi.png" alt="" className="w-6 h-6 flex-shrink-0" />
              <span className="text-[#333] text-xs font-bold w-[70px] flex-shrink-0">邮寄地址：</span>
              <input
                type="text"
                placeholder="请输入详细邮寄地址"
                value={form.address}
                onChange={e => setForm({ ...form, address: e.target.value })}
                className="flex-1 bg-[url(/images/tuipeika_shuru.png)] bg-cover bg-no-repeat rounded-lg px-3 py-1.5 text-xs text-[#333] placeholder-gray-400 outline-none focus:ring-2 focus:ring-[#c4161c]/20"
              />
            </div>
          </div>

          <div className="mt-3">
            <button onClick={handleSubmit} disabled={submitting} className="w-full disabled:opacity-60">
              <img src="/images/tuipeika_txiian.png" alt="立即提现" className="w-full" />
            </button>
          </div>

          <div className="mb-3">
            <button
              onClick={() => navigate('/card-progress')}
              className="w-full bg-white border border-gray-200 rounded-full py-2 flex items-center justify-center gap-2 shadow-sm"
            >
              <span className="text-[#333] text-sm font-bold">查看邮寄进度</span>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2"><path d="M9 18l6-6-6-6" /></svg>
            </button>
          </div>
        </div>
      </div>

      <div className="px-4 mt-4">
        <img src="/images/tuipeika_jieshoa.png" alt="退赔卡介绍" className="w-full" />
      </div>
    </div>
  );
}
